export default {
  gradeWithAIOpenApp: {
    id: 'buyback_funnel_device_grade_with_ai_open_app',
    defaultMessage: 'Grade with AI in the app',
  },
  gradeWithAIGetStarted: {
    id: 'buyback_funnel_device_grade_with_ai_get_started',
    defaultMessage:
      'Upload photos and AI does the rest. Click here to get started.',
  },
  gradeWithAIOr: {
    id: 'buyback_funnel_device_grade_with_ai_or',
    defaultMessage: 'Or',
  },
  gradeWithAIModalTitle: {
    id: 'buyback_funnel_device_grade_with_ai_modal_title',
    defaultMessage: 'Grade with AI',
  },
  gradeWithAIModalDescription: {
    id: 'buyback_funnel_device_grade_with_ai_modal_description',
    defaultMessage:
      'Scan the QR code to download the Back Market app and get started.',
  },
  gradeWithAITitle: {
    id: 'buyback_funnel_device_grade_with_ai_open_app',
    defaultMessage: 'Grade with AI in the app',
  },
}
